import { AdContainer } from "./ad-container";

interface ResponsiveAdProps {
  slot?: string;
  className?: string;
}

export function ResponsiveAd({ slot, className }: ResponsiveAdProps) {
  return <AdContainer format="auto" slot={slot} className={className} />;
}
